import React from "react";
import {
  FaHandshake,
  FaUsers,
  FaShieldAlt,
  FaCheckCircle,
  FaLightbulb,
} from "react-icons/fa";

import "./CoreValues.css";

export default function CoreValues() {

  const values = [

    {
      icon: <FaUsers />,
      title: "Customer Success",
      desc: "We measure our success by the success of our customers and deliver solutions that create lasting value.",
    },

    {
      icon: <FaHandshake />,
      title: "Transparency & Trust",
      desc: "Open communication, honesty and long-term partnerships form the foundation of our work.",
    },

    {
      icon: <FaShieldAlt />,
      title: "Ownership & Accountability",
      desc: "We take complete responsibility for every project and deliver with commitment and integrity.",
    },

    {
      icon: <FaCheckCircle />,
      title: "Quality Delivery",
      desc: "We build reliable, scalable and secure software while maintaining the highest quality standards.",
    },

    {
      icon: <FaLightbulb />,
      title: "Anticipate • Ship • Learn • Improve",
      desc: "We continuously innovate, learn from feedback and improve every solution we build.",
    },

  ];

  return (

    <section className="core-values">

      <h5>OUR CULTURE</h5>

      <h2>Core Values</h2>

      <p>
        Our values define how we work, collaborate and deliver exceptional
        software solutions to every client.
      </p>

      <div className="values-grid">

        {values.map((value, index) => (

          <div className="value-card" key={index}>

            <div className="value-header">

              <div className="value-icon">

                {value.icon}

              </div>

              <h3>{value.title}</h3>

            </div>

            <p>{value.desc}</p>

          </div>

        ))}

      </div>

    </section>

  );

}